import { FC, ReactNode } from 'react'

type Props = {
  children: ReactNode
  [x: string]: any
}

const Card: FC<Props> = ({ children, ...rest }) => {
  const { className: c, ...args } = rest
  const className =
    'w-auto md:w-11/12 md:max-w-lg my-0.5 md:my-2 mx-0.5 md:mx-auto py-8 px-2 bg-white rounded-lg border border-[#999999]/75 ' +
    (c ?? '')
  return (
    <div className={className} {...args}>
      {children}
    </div>
  )
}

export default Card
